/**
 * QuoteElement — F12.H T12.H.5.
 *
 * Cytat (`<blockquote>`) z opcjonalnym autorem. Renderowany z lewym
 * paskiem akcentowym (border-l) — typowy styl cytatu w UI.
 *
 * Settings shape:
 *   { text: string, author?: string }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

export const QuoteElement: LayoutElementDefinition = {
  type: 'quote',
  category: 'tresc',
  isContainer: false,
  label: 'Cytat',
  icon: 'Quote',
  defaultSettings: () => ({
    text: 'Treść cytatu',
    author: '',
  }),
  propertiesEditor: ({ settings, onChange }) => {
    const text = String(settings.text ?? '');
    const author = String(settings.author ?? '');
    return (
      <div className="space-y-3" data-testid="quote-properties-editor">
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">Treść cytatu</label>
          <textarea
            value={text}
            onChange={(e) => onChange({ text: e.target.value })}
            rows={3}
            className="w-full rounded-md border border-border-primary bg-bg-primary px-2 py-1 text-sm"
            data-testid="quote-prop-text"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">
            Autor (opcjonalnie)
          </label>
          <input
            type="text"
            value={author}
            onChange={(e) => onChange({ author: e.target.value })}
            className="w-full rounded-md border border-border-primary bg-bg-primary px-2 py-1 text-sm"
            data-testid="quote-prop-author"
          />
        </div>
      </div>
    );
  },
  render: ({ element, mode }) => {
    const settings = (element.settings ?? {}) as { text?: string; author?: string };
    const text = settings.text || (mode === 'builder' ? '(pusty cytat)' : '');
    const author = settings.author?.trim() ?? '';

    return (
      <blockquote
        className="border-l-4 border-accent-400 bg-bg-tertiary/40 py-2 pl-4 italic"
        data-testid={`quote-element-${element.id}`}
        data-element-type="quote"
      >
        <p className="text-sm text-text-secondary whitespace-pre-wrap">{text}</p>
        {author && (
          <footer className="mt-1 text-xs text-text-tertiary not-italic">— {author}</footer>
        )}
      </blockquote>
    );
  },
};
